import { AddressSuggestion } from '../types/AddressSuggestion';

export const isPoBox = (suggestion: AddressSuggestion): boolean => {
  const streetLine = suggestion.street_line.toLowerCase() || '';

  const poBoxPatterns = [
    /\bp\.?\s?o\.?\s?box\b/, // P.O. Box, PO Box, P O Box, etc.
    /\bpost\s?office\s?box\b/, // Post Office Box
    /\bp\.?\s?o\.?\s?b\.?\b/, // P.O.B., POB, P O B, etc.
    /\bpo\s?box\b/, // PO Box
    /\bpost\s?box\b/, // Post Box
    /^box\s?\d+/, // Box 123
  ];

  return poBoxPatterns.some((pattern) => pattern.test(streetLine));
};
